import { useEffect } from "react";

// A1 TCMS 실제 화면 이미지의 손쉬운 저장(우클릭·끌어서 저장)을 막는다.
// 화면 캡처는 막을 수 없으므로 이미지 자체에 워터마크·블러를 넣어 둔다 (scripts/protect_images.py)
const GUARDED = [
  "screen-classify-basic",
  "screen-classify-detail",
  "screen-search",
  "screen-legal",
  "screen-research",
  "02-customs-pipeline",
  "03-audit-risk",
  "04-ecommerce",
  "05-compliance",
  "06-supply-chain",
];
const SELECTOR = GUARDED.map((n) => `img[src*="${n}"]`).join(",");

// 이미지가 포인터를 받지 않게 해 "이미지 저장" 메뉴가 뜨지 않게 하고, 그 자리의 우클릭도 막는다
const CSS = `${SELECTOR}{pointer-events:none;user-select:none;-webkit-user-select:none;-webkit-user-drag:none;-webkit-touch-callout:none;}`;

const overGuarded = (x, y) =>
  [...document.querySelectorAll(SELECTOR)].some((img) => {
    const r = img.getBoundingClientRect();
    return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  });

const ImageGuard = () => {
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = CSS;
    document.head.appendChild(style);
    const block = (e) => {
      if (overGuarded(e.clientX, e.clientY)) e.preventDefault();
    };
    document.addEventListener("contextmenu", block);
    document.addEventListener("dragstart", block);
    return () => {
      style.remove();
      document.removeEventListener("contextmenu", block);
      document.removeEventListener("dragstart", block);
    };
  }, []);
  return null;
};
export default ImageGuard;
